





























































































































































































































































































































































































































































































































import Vue from "vue";
import ImageMap from "image-map";
import { DocumentTypePrimitive, AnchorType, DocumentAnchor, DocumentContent, InteractiveDocumentContent, Controllers } from "@infoland/iprova-api";
import Shared from "../../../shared";
import storeHelper from "../../../store/store-helper";
import Utils from "@/utils";
import { OfficeOnlineParams } from "@/types/OfficeOnlineParams";
import ZenyaDialog, { IZenyaDialog } from "@/components/dialogs/ZenyaDialog.vue";
import regexEscape from "regexp.escape";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { DocumentImage } from "@/types/document/documentImage";
import ZoomedImage from "./ZoomedImage.vue";
import * as UAS from "@/userapplicationstate";
import OfficeFillableFormDialog from "./OfficeFillableFormDialog.vue";
import startOfficeOnline from "@OfficeOnline";

export default Vue.extend({
    name: "DocumentViewer",
    props: {
        documentId: String,
        loadDocument: Boolean,
        bookmark: String,
        paragraph: Number,
        page: Number,
        initialContent: Object as () => DocumentContent | InteractiveDocumentContent | OfficeOnlineParams,
        documentURL: String,
        oldViewerUrl: String,
        initializing: Boolean,
        showTranslatedVersion: Boolean
    },
    components: { ZenyaDialog, ZoomedImage, OfficeFillableFormDialog },
    data: function () {
        return {
            documentProperties: null as DocumentVersionInfo,
            documentContent: null as DocumentContent,
            downloadLink: null as string,
            iLuminusContent: null as InteractiveDocumentContent,
            subjects: [] as DocumentAnchor[],
            processHyperlinks: false,
            documentIndexDrawer: false,
            glossaryDefinition: null as string,
            showGlossaryItem: false,
            showExternalLinkConfirmDialog: false,
            externalLinkConfirmDialogUrl: null as string,
            showOfficeFillableFormDialog: false,
            officeFillableFormDialog: null as string,
            image: null as DocumentImage,
            showImage: false,
            officeOnlineEnabled: false,
            resizing: false as boolean,
            showCancelTranslation: false
        };
    },
    updated() {
        this.$nextTick(function () {
            this.processContentHyperlinks();
            //apply image map to scale maps with responsive sized images
            ImageMap("img[useMap]");
        });
        document.querySelectorAll("video").forEach(b => {
            b.addEventListener("error", this.throwMediaError);
        });
        document.querySelectorAll("audio").forEach(b => b.addEventListener("error", this.throwMediaError));
        if (this.isStructuredDocument || this.isFreeWebDocument) {
            document.querySelectorAll("img").forEach(element => {
                if (element.parentElement.tagName.toLowerCase() != "a") {
                    element.classList.add("enlargeable");
                    element.addEventListener("click", this.setShowImage);
                }
            });
        }
    },
    beforeDestroy() {
        // Disable syle element [DF-66848]
        const styleElements = document.head.querySelectorAll("style");
        styleElements.forEach(styleElement => {
            if (styleElement.textContent.includes("@font-face") && styleElement.textContent.includes("Roboto")) {
                (styleElement as any).disabled = true;
            }
        });
    },
    computed: {
        isWebshareDocument(): boolean {
            if (this.documentProperties) return this.documentProperties.type == DocumentTypePrimitive.web_share;
            else return false;
        },
        isInteractiveDocument(): boolean {
            if (this.documentProperties)
                return (
                    this.documentProperties.type == DocumentTypePrimitive.interactive ||
                    (this.documentProperties.type == DocumentTypePrimitive.web_share &&
                        this.documentProperties.original_type == DocumentTypePrimitive.interactive)
                );
            else return false;
        },
        isStructuredDocument(): boolean {
            if (!this.documentProperties) return false;

            //document type is structured document
            if (this.documentProperties.type == DocumentTypePrimitive.structured_document) return true;

            //document is webshare document but it can also be a structured document
            if (
                this.documentProperties.original_type == DocumentTypePrimitive.structured_document &&
                this.documentProperties.type == DocumentTypePrimitive.web_share
            )
                return true;

            return false;
        },
        isFreeWebDocument(): boolean {
            if (this.documentProperties) return this.documentProperties.type == DocumentTypePrimitive.free_web;
            else return false;
        },
        showAsInlineObject(): boolean {
            if (!this.documentProperties) return false;

            //first check for pdf mimetype, because webshare document can also be pdf document. only on not mobile device
            if (this.documentProperties.mime_type == "application/pdf") return !this.isMobileDevice;

            if (this.documentProperties.type != DocumentTypePrimitive.file) return false;

            //is editable form?
            if (this.documentProperties.is_editable_form) return false;

            //office document?
            if (this.documentProperties.mime_type.match(/application\/(.+?officedocument.*)|(ms.*)/)) return false;

            //image document
            if (this.documentProperties.mime_type.match(/image\/.*/)) return false;

            //xml document
            if (this.documentProperties.mime_type.match(/.*\/xml/)) return false;

            //unknown type => just try, browser should fallback
            return true;
        },
        isMobileDevice(): boolean {
            return (
                /iphone|ipad|ipod|android/i.test(window.navigator.userAgent) ||
                (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 2) //ios13+ doesn't advertise itself as ipad anymore, this is the only way to detect an ipad
            );
        },
        documentMimeType(): string {
            if (!this.documentProperties) return null;

            //only ie11 has office type problems
            if (!Utils.isIE11) return this.documentProperties.mime_type;

            //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
            if (this.documentProperties.mime_type.startsWith("application/vnd.openxmlformats-officedocument")) {
                switch (this.documentProperties.mime_type.split(".")[2]) {
                    case "spreadsheetml":
                        return "application/msexcel";
                    case "presentationml":
                        return "application/mspowerpoint";
                    case "wordprocessingml":
                        return "application/msword";
                    default:
                        return this.documentProperties.mime_type;
                }
            }

            //default return
            return this.documentProperties.mime_type;
        },
        documentTitle(): string {
            if (this.documentProperties) {
                return `${this.documentProperties.title} (${this.$t("document.version")} ${this.documentProperties.version})`;
            }
            return "";
        },
        downloadTargetWindow(): string {
            if (/iphone|ipad|ipod/i.test(window.navigator.userAgent)) return "_blank";
            else return "_self";
        },
        downloadFilename(): string {
            return `${this.documentProperties.title}.${this.documentProperties.download_binary_extension}`;
        },
        showAsImage() {
            if (!this.documentProperties) return false;
            else if (this.documentProperties.mime_type.match(/image\/.*/))
                //image document
                return true;
            else return false;
        },
        htmlDocumentViewerClass(): string {
            if (this.$vuetify.breakpoint.smAndDown) return "";

            if (this.documentIndexDrawer) return "htmlDocumentContentWithTOC";
            else return "htmlDocumentContentWithoutTOC";
        }
    },
    watch: {
        documentIndexDrawer: async function (newValue: boolean) {
            if (this.$vuetify.breakpoint.mdAndUp) return UAS.set("TableOfContentsShown", newValue ? "1" : "0");
        },
        showImage: {
            handler: function () {
                this.onResize();
            }
        },
        initialContent: {
            immediate: true,
            handler: function (newValue: DocumentContent) {
                if (newValue) this.documentContent = newValue;
            }
        },
        documentContent: async function (newValue: DocumentContent) {
            await this.$nextTick();
            this.onResize();
        },
        iLuminusContent: async function (newValue: InteractiveDocumentContent) {
            if (newValue !== null) {
                await this.$nextTick();
                this.loadIluminusDocument();

                // enable style element (we disable it when on before destroy)
                const styleElements = document.head.querySelectorAll("style");
                styleElements.forEach(styleElement => {
                    if (styleElement.textContent.includes("@font-face") && styleElement.textContent.includes("Roboto")) {
                        (styleElement as any).disabled = false;
                    }
                });
            } else {
                this.disposeIluminusDocument();
            }
        },
        async loadDocument() {
            if (this.loadDocument) {
                this.documentProperties = storeHelper.documentStore.documentInfo;
                document.title = Utils.getPageTitle(this.documentTitle, "none"); //set the title for the html document, not the Zenya document
                if (this.documentProperties != null) await this.manageDocumentContentAsync();
                this.applyBorders();
                if (this.bookmark) {
                    this.jumpToBookmark(this.bookmark);
                }
                if (this.paragraph > -1) {
                    this.jumpToParagraph(this.paragraph);
                }
            } else {
                this.documentContent = null;
                if (this.iLuminusContent) {
                    this.disposeIluminusDocument();
                }
            }
        },
        subjects: function (newValue: DocumentAnchor[]) {
            this.$emit("set-comment-subject", newValue);
        },
        initializing: {
            immediate: true,
            handler: function (newValue) {
                if (newValue) {
                    setTimeout(() => {
                        if (this.showTranslatedVersion) {
                            this.showCancelTranslation = true;
                        }
                    }, 3000);
                } else {
                    this.showCancelTranslation = false;
                }
            }
        }
    },
    async mounted() {
        window.addEventListener("resize", this.onResize);
        this.documentIndexDrawer = (await UAS.get("TableOfContentsShown")) == "1" && this.$vuetify.breakpoint.mdAndUp;
        this.officeOnlineEnabled = await storeHelper.settingsStore.getSettingAsync<boolean>("officeonline_enabled");

        await this.$nextTick();
        this.fixTables();
    },
    methods: {
        cancelTranslation() {
            this.showCancelTranslation = false;
            this.$emit("change-translation", true);
        },
        setShowImage(event) {
            this.image = {
                source: event.currentTarget.getAttribute("src").trim(),
                width: event.currentTarget.naturalWidth,
                height: event.currentTarget.naturalHeight
            };
            this.showImage = true;
        },
        async onResize(): Promise<void> {
            if (!this.resizing) {
                this.resizing = true;
                if (this.isInteractiveDocument) {
                    this.setIluminusTopHeightAndRight();
                    this.resizing = false;
                } else if (this.documentContent) {
                    await this.$nextTick();
                    let documentViewContent = document.getElementById("documentViewContent")?.parentElement;
                    let documentViewContentWidth = 0;
                    if (documentViewContent) {
                        documentViewContentWidth = document.getElementById("documentViewContent").parentElement.getBoundingClientRect().width;
                    }
                    let fabButton = document.getElementById("fabButton");
                    if (fabButton) {
                        fabButton.style.width = (documentViewContentWidth - 100).toString() + "px";
                    }

                    this.fixTables();
                    this.resizing = false;
                }
            }
        },
        fixTables(): void {
            const tables: NodeListOf<HTMLElement> = document.querySelectorAll(".Tables") as NodeListOf<HTMLElement>;
            if (tables) {
                const width: number = document.querySelector(".htmlDocumentParagraph")?.getBoundingClientRect().width || 0;
                if (width) {
                    for (let t: number = 0; t < tables.length; t++) {
                        const container: HTMLElement = tables[t];
                        container.classList.remove("TooWide");
                        container.style.minWidth = "auto";
                        const padder: HTMLElement = container.firstElementChild as HTMLElement;
                        padder.style.width = "auto";
                        const table: HTMLElement = container.querySelector("table") as HTMLElement;
                        const savedTableAlign = container.getAttribute("data-table-align");
                        if (savedTableAlign) table.setAttribute("align", savedTableAlign);
                        const savedTableWidth = container.getAttribute("data-table-width");
                        if (savedTableWidth) table.style.maxWidth = savedTableWidth;
                        else table.style.removeProperty("maxWidth");
                        let tableWidth: number = Math.ceil(table.getBoundingClientRect().width);

                        if (tableWidth > width) {
                            const border: string = table.getAttribute("border");
                            let borderAdjust: number = 0;
                            if (border) {
                                const borderNum: number = parseInt(border, 10);
                                if (!isNaN(borderNum)) borderAdjust = borderNum;
                            }

                            tableWidth -= borderAdjust;
                            padder.style.width = `${tableWidth}px`;
                            const tableAlign = table.getAttribute("align");
                            if (tableAlign) {
                                table.removeAttribute("align");
                                container.setAttribute("data-table-align", tableAlign);
                            }
                            table.style.maxWidth = `${tableWidth}px`;
                            const fullWidth: number = document.querySelector("#documentViewContent").clientWidth;
                            container.style.minWidth = fullWidth + "px";
                            container.classList.add("TooWide");
                        }
                    }
                }
            }
        },
        setIluminusTopHeightAndRight() {
            const iLuminusViewer: HTMLElement = document?.getElementById("objIluminusViewer");
            if (iLuminusViewer) {
                iLuminusViewer.style.top = (this.$vuetify.breakpoint.smAndDown ? 55 : 64).toString() + "px";
                if (this.$parent.$refs.commentsDrawer) {
                    iLuminusViewer.style.right = (this.$parent.$refs.commentsDrawer as Vue).$el.clientWidth.toString() + "px";
                }
            }
        },
        throwMediaError(event): void {
            (window as any).mediaErrorHandler(event);
        },
        loadIluminusDocument(): void {
            //Add iLuminus viewer script (if not done yet)
            let iLuminusViewerScriptElement: Element = document.getElementById("iLuminusViewerScript");
            if (!iLuminusViewerScriptElement) {
                iLuminusViewerScriptElement = document.createElement("script");
                iLuminusViewerScriptElement.id = "iLuminusViewerScript";
                iLuminusViewerScriptElement.setAttribute("src", this.iLuminusContent.viewer_script_url);
                document.head.appendChild(iLuminusViewerScriptElement);
            }

            //create iLuminus element
            let iLuminusViewer: Element = document.createElement("iluminus-viewer");
            iLuminusViewer.setAttribute("mode", "interactive");

            iLuminusViewer.setAttribute("position", "relative");

            iLuminusViewer.id = "objIluminusViewer";
            iLuminusViewer.addEventListener("load", this.onIluminusLoaded);

            //add element to iLuminus container
            const iLuminusContainer = document.getElementById("iLuminusContainer");
            iLuminusContainer.appendChild(iLuminusViewer);
            this.setIluminusTopHeightAndRight();
        },
        getDocumentIndexTree() {
            const result = [];
            if (this.documentContent && this.documentContent.paragraphs) {
                for (const paragraph of this.documentContent.paragraphs) {
                    if (this.isStructuredDocument && paragraph.content.length) {
                        result.push({
                            id: paragraph.paragraph_id,
                            name: paragraph.title,
                            level: 1,
                            parentId: null,
                            children: this.getIndexTreeFromContent(paragraph.content)
                        });
                    } else {
                        result.push(...this.getIndexTreeFromContent(paragraph.content));
                    }
                }
            }

            return result;
        },
        getIndexTreeFromContent(content: string) {
            const regexContentHeadings: RegExp = /<h([1-8])(?:\s+\w+=\s*"[^"]*")*\s+id=\s*"([^"]*)"(?:\s+\w+=\s*"[^"]*")*\s*>(.*?)<\/h[0-9]*>/g;
            const result = [];
            const headingStrings: string[] = content.match(regexContentHeadings);

            if (headingStrings) {
                //Digest HTML strings to object array
                const headings = [];
                for (const headingString of headingStrings) {
                    const headingLevel = parseInt(headingString.replace(regexContentHeadings, "$1"));
                    const headingName = headingString.replace(regexContentHeadings, "$3").replace(/<\/?[^>]+(>|$)/g, "");
                    if (headingName.trim().length > 0) {
                        headings.push({
                            id: headingString.replace(regexContentHeadings, "$2"),
                            name: headingName,
                            level: headingLevel,
                            parentId: this.findParentHeadingId(headings, headingLevel),
                            children: []
                        });
                    }
                }
                //Build tree structure
                for (const heading of headings) {
                    if (heading.parentId !== null) {
                        headings.find(x => x.id == heading.parentId).children.push(heading);
                    } else {
                        result.push(heading);
                    }
                }
            }
            return result;
        },
        findParentHeadingId(headings: any[], level: number): string {
            const lowestLevel = [...headings].sort(function (a, b) {
                return a.level - b.level;
            })[0]?.level;

            if (level !== lowestLevel) {
                //Get last lower level heading element id
                for (let index = headings.length - 1; index >= 0; index--) {
                    const heading = headings[index];
                    if (heading.level < level) {
                        return heading.id;
                    }
                }
            }

            return null;
        },
        async manageDocumentContentAsync(): Promise<void> {
            this.subjects = [
                {
                    id: null,
                    text: this.$t("comment.commentDefaultSubject") as string,
                    type: AnchorType.document
                }
            ];
            if (Utils.isIE11 && this.documentProperties.type == DocumentTypePrimitive.interactive) {
                window.open(this.oldViewerUrl.toString(), "_self");
                return;
            } else if (this.documentProperties.show_in_office_online_viewer) {
                this.startOfficeViewer();
            } else if (
                this.documentProperties.type == DocumentTypePrimitive.objective_matrix ||
                this.documentProperties.type == DocumentTypePrimitive.process ||
                (this.documentProperties.type == DocumentTypePrimitive.web_share &&
                    (this.documentProperties.web_share_source_document_type_primitive == DocumentTypePrimitive.objective_matrix ||
                        this.documentProperties.web_share_source_document_type_primitive == DocumentTypePrimitive.process))
            ) {
                window.open(this.oldViewerUrl, "_self");
                return;
            } else if (this.documentProperties.can_download_content) {
                if (this.isInteractiveDocument) {
                    //iLuminus document
                    //load iLuminus document content
                    let docContent: InteractiveDocumentContent = this.initialContent as InteractiveDocumentContent;
                    if (docContent && docContent.content != "") {
                        //Fill iLuminus content
                        this.iLuminusContent = docContent;
                        this.subjects = this.subjects.concat(docContent.anchors);
                    }
                } //Other documents
                else {
                    //load document content
                    let docContent: DocumentContent = this.initialContent as DocumentContent;
                    if (docContent) {
                        //Prefix stylesheet
                        if (docContent.stylesheet !== null) {
                            const classPrefix: RegExp = new RegExp(/([^\s\r\n,{}]+)(,(?=[^}]*{)|\s*{)/, "g");
                            docContent.stylesheet = docContent.stylesheet.replace(classPrefix, ".ContentView $1 $2");
                            let firstInlineStyle = document.getElementsByTagName("style")[0];
                            let styleTag = document.createElement("style");
                            styleTag.setAttribute("type", "text/css");
                            styleTag.textContent = docContent.stylesheet;
                            await firstInlineStyle.parentNode.insertBefore(styleTag, firstInlineStyle);
                        }

                        //Parse document content tables, paragraphs bookmarks and media items
                        for (let i = 0; i < docContent.paragraphs.length; i++) {
                            let paragraphContent: string = docContent.paragraphs[i].content;
                            docContent.paragraphs[i].content = this.parseContent(paragraphContent);

                            if (this.isStructuredDocument) {
                                //Push subjects into subjects as items
                                this.subjects.push({
                                    id: docContent.paragraphs[i].document_version_paragraph_id,
                                    text: docContent.paragraphs[i].title,
                                    type: AnchorType.paragraph
                                });
                            }
                        }
                        this.subjects = this.subjects;

                        //Fill document content
                        this.documentContent = docContent;

                        //initiate new thread to apply glossary
                        setTimeout(async () => {
                            try {
                                if (!storeHelper.glossaryStore.termsLoaded) await storeHelper.glossaryStore.loadGlossaryAsync();
                                this.applyGlossary();
                            } catch (error) {
                                //eat errors, so this does not break page
                                console.warn("error occured when applying glossary ", error);
                            }
                        }, 500);
                        this.onResize();
                    } else {
                        storeHelper.siteStore.setSnackBarMessage(this.$t("document.loadError") as string, true);
                    }
                }
            } else if (this.documentProperties.can_download_binary) {
                //Downloadable binary
                this.downloadLink = this.documentURL;
                if (this.page > -1) {
                    this.downloadLink += "#page=" + this.page;
                }
            } else {
                //auto open old-viewer when screen is big enough
                if (this.$vuetify.breakpoint.mdAndUp) {
                    //auto open old viewer
                    window.open(this.oldViewerUrl);
                }
            }

            // show changes since previous version when has content
            if (this.documentProperties.can_download_binary || this.documentProperties.can_download_content) {
                this.$emit("document-has-content");
            }
            this.$emit("set-initializing", false);
        },
        parseContent(input: string) {
            input = this.removeEmptyContent(input);
            input = this.parseTables(input);
            input = this.parseMediaItems(input);
            return input;
        },
        removeEmptyContent(input: string): string {
            const testElement = document.createElement("div");
            testElement.innerHTML = input;

            if (testElement.textContent.trim().length == 0) {
                //check for img, media (video/audio) and other visible elements
                if (testElement.querySelector("img, mediaitem, hr") == null) {
                    //no visible elements => empty
                    return "";
                }
            }
            return input;
        },
        parseTables(input: string) {
            const tableStartTagRegularExpression: RegExp = new RegExp(/<table[^>]*>/, "g");
            const tableEndTagRegularExpression: RegExp = new RegExp(/<\/table>/, "g");

            input = input.replace(tableStartTagRegularExpression, '<div class="Tables"><div class="Padder">$&');
            input = input.replace(tableEndTagRegularExpression, "$&</div></div>");

            return input;
        },
        async startOfficeViewer() {
            let params = this.initialContent as OfficeOnlineParams;

            let viewerElement: HTMLElement = document.getElementById("officeonlineviewer");

            if (viewerElement) {
                startOfficeOnline(params.AccessToken, params.AccessTokenTtl, params.ActionUrl, viewerElement, null);
            } else {
                if (this.documentProperties.show_in_office_online_viewer) {
                    setTimeout(async () => this.startOfficeViewer(), 500);
                }
            }
        },
        parseMediaItems(input: string) {
            const mediaRegularExpression: RegExp = new RegExp(/<mediaitem([^>]*)>\s*<\/mediaitem>/, "g");

            return input.replace(mediaRegularExpression, this.mediaItemMatched);
        },
        mediaItemMatched(match: string) {
            const typePattern: RegExp = new RegExp(/data-type=\"([^\"]*)/, "g");
            const documentMediaItemIdPattern: RegExp = new RegExp(/data-document-media-item-id=\"([^\"]*)/, "g");

            let type: string = typePattern.exec(match)[1];
            let documentMediaItem: string = documentMediaItemIdPattern.exec(match)[1];

            if (type === "video" || type === "audio") {
                let url = Shared.GetAuthenticatedUrl(`${Shared.iProvaApiUrl}/documents/document_media/${documentMediaItem}/download`);
                return `<${type} controls controlsList="nodownload" oncontextmenu="return false;" src="${url}">${this.$t(
                    "document.browserMediaNotSupported",
                    { type: type }
                )}</${type}>`;
            } else {
                return `<span class="Thick">${this.$t("document.mediaNnotSupported", {
                    type: type
                })}</span>`;
            }
        },
        applyGlossary(): void {
            //find the document content elemens

            const contentElements = this.$refs["DocumentContent"] as Element[];
            if (!contentElements) {
                return;
            }

            const glossary = storeHelper.glossaryStore.terms;
            var glossaryTerms = Object.keys(glossary);
            if (glossaryTerms.length == 0) return;

            const glossaryTermsRegExps: { [key: string]: { expression: string; regex: RegExp } } = {};
            for (const word of glossaryTerms) {
                const escapedWord = regexEscape(word);

                let wordRegexString = escapedWord;
                wordRegexString = wordRegexString.replace(/[aáàäâãåāăảæ]/g, "[aáàäâãåāăảæ]");
                wordRegexString = wordRegexString.replace(/[cç]/g, "[cçÇ]");
                wordRegexString = wordRegexString.replace(/[eéèëê]/g, "[eéèëê]");
                wordRegexString = wordRegexString.replace(/[iíìïî]/g, "[íìïîi]");
                wordRegexString = wordRegexString.replace(/[nñ]/g, "[nñ]");
                wordRegexString = wordRegexString.replace(/[oóòöôõøőœ]/g, "[oóòöôõøőœ]");
                wordRegexString = wordRegexString.replace(/[sßš]/g, "[sßš]");
                wordRegexString = wordRegexString.replace(/[uúùüû]/g, "[uúùüû]");
                wordRegexString = wordRegexString.replace(/[yýÿ¥]/g, "[yýÿ¥]");
                wordRegexString = wordRegexString.replace(/[zżž]/g, "[zżž]");

                try {
                    //instantiate regex for word here so we don't need to re create is for each element in the next loop
                    // do not use global in this case, otherwise the regexp will keep a lastindex and wont match multiple words.
                    glossaryTermsRegExps[word] = { expression: wordRegexString, regex: new RegExp(`${wordRegexString}`, "i") }; // case insensitive
                } catch (error) {
                    //catch regex error, log it and continue
                    console.warn("there was a problem with glossary item", word, error);
                }
            }

            //test all elements to find out which glossary items occurs, so we can match for only those later
            //(matching all in all text nodes is a too heavy load)
            const elementWithGlossaryWords: Element[] = [];
            const matchedGlossaryExpressions: typeof glossaryTermsRegExps = {};
            for (const element of contentElements) {
                for (const word in glossaryTermsRegExps) {
                    const wordRegex = glossaryTermsRegExps[word];

                    if (wordRegex.regex.test(element.textContent)) {
                        if (!elementWithGlossaryWords.includes(element)) elementWithGlossaryWords.push(element);
                        if (!matchedGlossaryExpressions[word]) matchedGlossaryExpressions[word] = wordRegex;
                    }
                }
            }

            //get all text nodes
            const textNodes: Node[] = [];
            // build a regex pattern to find element containing any of those words
            const matchedWordsExpressionGroups: string[] = [];
            //make named groups so we can find wich glossary word the expression belongs to after matching it
            const matchedWords = Object.keys(matchedGlossaryExpressions);
            for (let index = 0; index < matchedWords.length; index++) {
                const mWord = matchedWords[index];
                const wordExpression = matchedGlossaryExpressions[mWord];
                //cannot use word itself as group name cause that can have invalid characters
                matchedWordsExpressionGroups.push(`(${wordExpression.expression})`);
            }

            //single regex to match any of the words that match somewhere
            let anyMatchedWordExpression: string = `(^|[^a-zA-Z0-9_&aáàäâãåāăảæcçÇeéèëêíìïîinñoóòöôõøőœsßšuúùüûyýÿ¥zżž])(${matchedWordsExpressionGroups.join(
                "|"
            )})(?=$|[^a-zA-Z0-9_&aáàäâãåāăảæcçÇeéèëêíìïîinñoóòöôõøőœsßšuúùüûyýÿ¥zżž])`;
            // do not use global in this case, otherwise the regexp will keep a lastindex and wont match multiple words.
            const anyWordRegex = new RegExp(anyMatchedWordExpression, "i"); // case insensitive

            let acceptNode: (n: Node) => number = n => {
                //IE11 does not have parentElement on Node object therefor we take the parent from parentNode and cast it to HTMLElement
                const parentNodeAsElement: HTMLElement = n.parentNode as HTMLElement;
                //skip a-elements with hrefs
                if (parentNodeAsElement.tagName === "A" && parentNodeAsElement.getAttribute("href")) {
                    return NodeFilter.FILTER_REJECT;
                }

                //only accept when any glossary word matched
                if (anyWordRegex.test(n.textContent)) {
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    return NodeFilter.FILTER_REJECT;
                }
            };

            let nodeFilter: NodeFilter | typeof acceptNode;
            if (!Utils.isIE11) {
                nodeFilter = {
                    acceptNode: acceptNode
                };
            } else {
                nodeFilter = acceptNode;
            }

            //iterate the elements that have a glossary item
            for (const element of elementWithGlossaryWords) {
                //find text nodes in the elements with a TreeWalker (https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker)
                const walker = (document as any).createTreeWalker(
                    element,
                    NodeFilter.SHOW_TEXT,
                    nodeFilter as NodeFilter, //IE11 takes the function as input, not a NodeFilter object
                    false //IE11 requires this overload
                );

                let node: Node;
                while ((node = walker.nextNode())) {
                    textNodes.push(node);
                }
            }

            //process all text nodes with any glossary word
            for (const textNode of textNodes) {
                const newTextNodes: Node[] = [];
                const text = textNode.textContent;

                //match content on previously detected terms
                const termRegex = new RegExp(anyMatchedWordExpression, "gi");

                let match: RegExpExecArray;
                let lastMatchEnd: number = 0;

                while ((match = termRegex.exec(text)) !== null) {
                    //create new text node of the text before the match

                    if (match.index > 0) {
                        const matchDiff: number = match[0].length - match[2].length; // matched a word boundary character before the word
                        newTextNodes.push(document.createTextNode(match.input.substring(lastMatchEnd, match.index + matchDiff)));
                    }
                    //find the matched group
                    let glossaryWord: string = null;

                    //find out which group matched
                    for (let index = 3; index < match.length; index++) {
                        //start loop at index 3 cause the 0 and 1 and 2 are whole expression and the word-boundary groups, and the specifically matched word
                        if (match[index]) {
                            //if match-index has a value, that index is +2 of the word index in matchedWords
                            glossaryWord = matchedWords[index - 3];
                            break; //end this for loop
                        }
                    }

                    //create new SPAN node and put the matched word in there
                    const glossarySpan = document.createElement("span");
                    let word = match[2]; //the matched word
                    glossarySpan.className = "GlossaryItem";
                    glossarySpan.textContent = word;
                    //set the glossary word as data attribute so the event handler can use it to get definition
                    glossarySpan.setAttribute("data-glossary", glossaryWord);
                    glossarySpan.addEventListener("click", this.glossaryItemClicked);
                    newTextNodes.push(glossarySpan);

                    //update last match end
                    lastMatchEnd = termRegex.lastIndex;
                }

                //any text remaining after last match?
                if (lastMatchEnd < text.length - 1) {
                    //create new text node of the text after the match
                    newTextNodes.push(document.createTextNode(text.substring(lastMatchEnd)));
                }

                //now replace used textNode with the new nodes
                const parentNode = textNode.parentNode;
                for (const newNode of newTextNodes) {
                    parentNode.insertBefore(newNode, textNode);
                }
                parentNode.removeChild(textNode);
            }
        },
        /**
         * Apply the border styling to the elements that have a (unsupported) border attribute
         */
        applyBorders(): void {
            const contentElements = this.$refs["DocumentContent"] as HTMLElement[];
            if (!contentElements) return;

            //Find all elements in contentElements that have a border attribute
            const elementsWithBorder = [];
            for (const element of contentElements) {
                elementsWithBorder.push(...element.querySelectorAll("[border]"));
            }

            //Apply the border styling to the elements
            for (const element of elementsWithBorder) {
                const borderValue = element.getAttribute("border");
                if (borderValue) {
                    element.style.border = borderValue.replace("%", "") + "px solid";
                }
            }
        },
        glossaryItemClicked(e: Event) {
            //get the real glossary word
            const word = (e.currentTarget as Element).getAttribute("data-glossary");

            this.showGlossaryItem = true;
            storeHelper.glossaryStore
                .getDefinitionAsync(word)
                .then(def => {
                    this.glossaryDefinition = def;
                })
                .catch(() => {
                    this.glossaryDefinition = this.$t("general.messages.error") as string;
                });
        },
        processContentHyperlinks(): void {
            const documentViewContent = document.getElementById("documentViewContent");
            if (documentViewContent) {
                let hyperlinks = documentViewContent.querySelectorAll("a[href], area[href]"); // a (default hyperlink) and area (media flowchart item)

                for (var i = 0; i < hyperlinks.length; i++) {
                    let linkElement = hyperlinks[i] as HTMLLinkElement;

                    linkElement.removeEventListener("click", this.onContentHyperlinkClicked);
                    linkElement.addEventListener("click", this.onContentHyperlinkClicked);
                }
            }
        },
        onContentHyperlinkClicked(e: Event): boolean | void {
            let linkElement = e.currentTarget as HTMLAnchorElement;
            let href = linkElement.getAttribute("href");

            if (href) {
                let paragraphPreFix = "iDocParagraphBookmark_";
                //link to paragraph
                if (href.startsWith("#" + paragraphPreFix)) {
                    this.jumpToParagraph(Number(href.replace("#" + paragraphPreFix, "")));

                    e.preventDefault();
                    return false;
                }
                //link to bookmark
                else if (href.startsWith("#")) {
                    this.jumpToBookmark(href);

                    e.preventDefault();
                    return false;
                }

                //webshare document ?
                if (this.isWebshareDocument) {
                    if (!href.startsWith(Shared.iProvaUrl)) {
                        //link to external page
                        this.openLinkToExternalPage(href);
                        e.preventDefault();
                        return false;
                    } else {
                        //just follow the link
                        return true;
                    }
                }
            }

            //Other target
            let hyperlinkId: string = linkElement.dataset.hyperlinkid;

            if (hyperlinkId) {
                this.$emit("hyperlink", { id: hyperlinkId, openInNewTab: true });

                e.preventDefault();
                return false;
            }
        },
        openLinkToExternalPage(href: string): void {
            //link to external page
            this.externalLinkConfirmDialogUrl = href;
            (this.$refs["externalLinkConfirmDialog"] as Vue & IZenyaDialog).open().then(go => {
                if (go) {
                    window.open(href, "_blank");
                }
            });
        },
        jumpToParagraph(paragraphId: number) {
            if (!paragraphId) return;

            let documentViewContent = document.getElementById("documentViewContent");
            let toAnchor: HTMLAnchorElement = null;

            if (this.isStructuredDocument) {
                toAnchor = documentViewContent.querySelector(`#documentViewParagraph_${paragraphId}`) as HTMLAnchorElement;
            }

            if (!toAnchor) {
                toAnchor = documentViewContent.querySelector(`#${paragraphId}`) as HTMLAnchorElement;
            }

            if (toAnchor) {
                toAnchor.scrollIntoView({ behavior: "smooth" });
            }
        },
        jumpToBookmark(bookmark: string) {
            if (!bookmark) return;

            //We need to escape the bookmark to make sure it is valid voor css selection. (DF-64313)
            if (bookmark.startsWith("#")) bookmark = bookmark.substring(1);
            const escapedBookmark = CSS.escape(bookmark);

            //Find target
            const documentViewContent = document.getElementById("documentViewContent");
            let toAnchor = documentViewContent?.querySelector(`a#${escapedBookmark}`) as HTMLAnchorElement;

            if (toAnchor) {
                toAnchor.scrollIntoView({ behavior: "smooth" });
            }
        },
        async onIluminusLoaded(e: Event): Promise<void> {
            const iLuminusViewer: Element = e.srcElement as Element;
            if (!storeHelper.glossaryStore.termsLoaded) await storeHelper.glossaryStore.loadGlossaryAsync();
            var glossary = [];
            Object.entries(storeHelper.glossaryStore.terms).forEach(([key, value]) => {
                glossary.push({ word: value, cssClass: "GlossaryItem" });
            });
            (iLuminusViewer as any).open({
                content: this.iLuminusContent.content,
                imageResolver: this.iLuminusResolveMediaItem,
                videoResolver: this.iLuminusResolveMediaItem,
                linkResolver: this.iLuminusResolveHyperlink,
                glossaryResolver: this.iLuminusResolveGlossaryItem,
                glossary: glossary,
                accentcolor: this.$vuetify.theme.currentTheme.primary,
                secondaryaccentcolor: this.$vuetify.theme.currentTheme.primary,
                language: this.documentProperties?.language || this.$user.language
            });

            if (this.bookmark) (iLuminusViewer as any).gotoHeader(this.bookmark);
        },
        iLuminusResolveMediaItem(mediaItemId) {
            return {
                url: Shared.GetAuthenticatedUrl(`${Shared.iProvaApiUrl}/documents/document_media/${mediaItemId}/download`)
            };
        },
        iLuminusResolveGlossaryItem(strGlossaryWord) {
            return new Promise((resolve, reject) => {
                let url = Shared.iProvaUrl + `/iDocument/Viewers/Frameworks/TermDefinitionHandler.ashx?term=${strGlossaryWord}`;
                Controllers.GenericController.postAsync(url, null).then(result => resolve(result));
            });
        },
        iLuminusResolveHyperlink() {
            return { click: this.iLuminusOpenHyperlinkCallback };
        },
        async iLuminusOpenHyperlinkCallback(hyperlinkId): Promise<void> {
            if (this.isWebshareDocument) {
                //resolve webshare hyperlink
                const resolvedLink = await Controllers.GenericController.getAsync<{ target: { url: string } }>(
                    `documents/webshare_hyperlinks/${hyperlinkId}`,
                    true
                );
                if (resolvedLink?.target.url) {
                    const targetUrl = resolvedLink.target.url;
                    if (!targetUrl.startsWith(Shared.iProvaUrl)) {
                        this.openLinkToExternalPage(targetUrl);
                    } else {
                        window.open(resolvedLink.target.url);
                    }
                }
            } else {
                this.$emit("hyperlink", { id: hyperlinkId, openInNewTab: true });
            }
        },
        disposeIluminusDocument(): void {
            const iLuminusContainer: Element = document.getElementById("iLuminusContainer");
            if (iLuminusContainer) {
                let iLuminusElement = iLuminusContainer.firstElementChild;
                if (iLuminusElement) {
                    iLuminusElement.remove();
                }
            }
        },
        scrollToAnchor(anchorId: string): void {
            if (!anchorId) return;
            if (this.isInteractiveDocument) {
                const objIluminusViewer = document.getElementById("objIluminusViewer") as any;
                if (objIluminusViewer) {
                    objIluminusViewer.gotoHeader(anchorId);
                }
            } else {
                let toAnchor = document.getElementById("p_" + anchorId);
                if (toAnchor) {
                    toAnchor.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    }
});
